import { Koi } from '@ksyos/koi';
import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { getTextAreaStringSchema } from '@common/validation/utils/getTextAreaStringSchema';

export type BariPreCloseProcessPrematurelyData = {
    reden_besluit: string | null;
    sluit_proces: boolean;
};

export type BariPreCloseProcessPrematurelyReadKey = keyof BariPreCloseProcessPrematurelyData;
export type BariPreCloseProcessPrematurelyReadLabel = 'Reden besluit';

export const bariPreCloseProcessPrematurelyReadSchema: TypedReadSchema<
    BariPreCloseProcessPrematurelyReadKey,
    BariPreCloseProcessPrematurelyReadLabel
>[] = [
    {
        items: [{ key: 'reden_besluit', label: 'Reden besluit' }],
    },
];

const bariPreCloseProcessPrematurelyFinal: TypedSchema<BariPreCloseProcessPrematurelyData> = {
    reden_besluit: getTextAreaStringSchema(),
    sluit_proces: Koi.boolean().valid(true),
};

// sluit_proces shouldn't be saved in the draft
const bariPreCloseProcessPrematurelyDraft: TypedSchema<Omit<BariPreCloseProcessPrematurelyData, 'sluit_proces'>> = {
    reden_besluit: getTextAreaStringSchema(true),
};

export const bariPreCloseProcessPrematurelyDraftSchema = Koi.object(bariPreCloseProcessPrematurelyDraft);
export const bariPreCloseProcessPrematurelyFinalSchema = Koi.object(bariPreCloseProcessPrematurelyFinal);
